<script>
  import { twMerge } from 'tailwind-merge';

  const {
    alert = false,
    size = 'md',
    class: className = '',
    children,
  } = $props();

  const classes = $derived(
    twMerge(
      'inline-block p-[2px] px-[4px] leading-none self-center font-mono rounded bg-gray-7 text-white',
      alert && 'bg-cta',
      size === 'xs' && 'text-[10px] p-[2px] px-[2px]',
      size === 'md' && 'text-[12px] p-[2px] px-[6px]',
      size === 'lg' && 'text-[14px] p-[2px] px-[8px]',
      size === 'xl' && 'text-[16px] p-[2px] px-[10px]',
      className,
    ),
  );
</script>

<div class={classes}>
  {@render children?.()}
</div>
